import { useMemo } from 'react';
import { CssBaseline } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Router } from './router';
import { ColorModeProvider, useColorMode } from './theme';

const ThemedApp = () => {
  const { mode } = useColorMode();

  const theme = useMemo(
    () =>
      createTheme({
        components: {
          MuiTextField: {
            defaultProps: {
              sx: { mt: 2, mb: 0 },
              variant: 'outlined',
            },
          },
          MuiAutocomplete: {
            defaultProps: {
              sx: { m: 0 },
            },
          },
          MuiSelect: {
            defaultProps: {
              variant: 'outlined',
            },
          },
          MuiButton: {
            defaultProps: {
              variant: 'contained',
            },
          },
        },
        palette: {
          mode,
          background: {
            default: mode === 'dark' ? '#121212' : '#e5e5e5',
            paper: mode === 'dark' ? '#1e1e1e' : '#fff',
          },
        },
      }),
    [mode]
  );

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router />
    </ThemeProvider>
  );
};

export default function App() {
  return (
    <ColorModeProvider>
      <ThemedApp />
    </ColorModeProvider>
  );
}
